import React, { useContext, useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { SuccessAlertContext } from "App";
import { useNavigate } from "react-router";
import Notify from "config/notify";
import ERROR_MESSAGE from "constants/message";
import { checkAccessTokenExpired } from "util/auth";
import uploadRPACsv from "../api/uploadRPACsv";
import { localEnv } from "../constants";

/**
 * RPA用店舗BOのCSVのUpload画面
 */
export default function RPACsvUpload() {
  const [file, setFile] = useState<File | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate()

  const { showAlert } = useContext(SuccessAlertContext);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0] ?? null;
    setFile(selected);
  };

  const handleUpload = async () => {
    if (!file) {
      showAlert("CSVファイルを選択してください", "error");
      return;
    }
    // アップロード処理をここに実装
    console.log("Uploading:", file);
    setIsLoading(true);
    try {
      const params = {
        csv_file: file,
      };
      await uploadRPACsv(params);
    } catch (err) {
      console.error(err);
      showAlert("アップロード処理に失敗しました。", "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    // 戻る処理をここに実装（例：history.back()など）
    navigate(-1)
  };

  useEffect(() => {
    setTimeout(() => {
      (async () => {
        const userType = localStorage.getItem("user_type");
        if (!localEnv && !(userType === "C0001" || userType === "C0005")) {
          Notify?.setNotification?.({
            show: true,
            title: ERROR_MESSAGE.UNAUTHORIZED.TITLE,
            message: "本部ユーザーでログインしてください。再度ログインしてください。",
          });
          Notify.onClose = () => {
            localStorage.clear();
            window.location.href = "/login";
          };
        } else if (!localEnv && checkAccessTokenExpired()) {
          // 期限切れなら
          Notify?.setNotification?.({
            show: true,
            title: ERROR_MESSAGE.UNAUTHORIZED.TITLE,
            message: ERROR_MESSAGE.UNAUTHORIZED.MESSAGE,
          });
          Notify.onClose = () => {
            localStorage.clear();
            window.location.href = "/login";
          };
        }
      })();
    }, 0);
  }, []);

  return (
    <Box width="90%" alignSelf="center" marginLeft="5%" minHeight={330} position="relative" pt={0}>
      <Box>
        <Box position="absolute" top={32} left={0} width="100%" textAlign="center">
          <Typography fontSize={22}>RPA用店舗BO・CSVアップロード</Typography>
        </Box>
        <Box sx={{ position: "relative", width: "100%", height: "calc(100vh - 50px)" }}>
          {/* 真ん中の plain HTML input */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              height: "100%",
            }}
          >
            <input
              type="file"
              accept=".csv"
              onChange={handleFileChange}
              style={{ width: "auto" }}
            />
          </Box>

          {/* 右下のボタン */}
          <Box
            sx={{
              position: "absolute",
              bottom: 16,
              right: 0,
              display: "flex",
              gap: 1,
            }}
          >
            <Button variant="custom-outlined" onClick={handleBack}>
              戻る
            </Button>
            <Button variant="contained" color="primary" onClick={handleUpload}>
              アップロード
            </Button>
          </Box>
        </Box>
      </Box>
      {isLoading && ( // マスク
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            bgcolor: "rgba(0,0,0,0.2)",
            zIndex: (theme) => theme.zIndex.modal + 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
}
